import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import {useLocation} from "react-router-dom";
import {useHistory} from "react-router-dom";
import {Icon, Checkbox} from "@blueprintjs/core";

// Libs
import {useAuth} from "../auth/auth";

// Components
import Button from "../common/components/button";
import PasswordInput from "../common/components/password-input";

const ResetPasswordPage = () => {

    // get welcome password token from params
    const location = useLocation();

    // redirect to login
    const history = useHistory();
    const to = "/login";

    // token
    const token = location.pathname.split("/reset-password/")[1];

    // i18n
    const {t} = useTranslation("welcome");

    // State
    const [password, setPassword] = useState({value: "", isValid: false});
    const [verifyPassword, setVerifyPassword] = useState({value: "", isValid: false});
    const [privacy, setPrivacy] = useState(false);

    const [validInputs, setValidInputs] = useState({
        validLength: false,
        validLower: false,
        validUpper: false,
        validNumber: false,
        validSpecial: false
    });
    const [validForm, setValidForm] = useState(false);

    // Hooks
    const auth = useAuth();

    const handleEnter = (event) => {
        // if (event.keyCode === 13) auth.login(user.email, password);
    };

    // form validation
    function validatePassword(password) {
        const validLength = password.length >= 6;
        const validLower = password.search(/[a-z]/) !== -1;
        const validUpper = password.search(/[A-Z]/) !== -1;
        const validNumber = password.search(/[0-9]/) !== -1;
        const validSpecial = password.search(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) !== -1;

        setValidInputs({validLength: validLength, validLower: validLower, validUpper: validUpper, validNumber: validNumber, validSpecial: validSpecial});

        const isValid = validLength && validUpper && validLower && validNumber && validSpecial;

        setPassword({value: password, isValid: isValid});
    }

    function valueVerifyPassword(value) {
        setVerifyPassword({value: value});
    }

    function validateForm() {
        password.isValid && (password.value === verifyPassword.value) && privacy ?
            setValidForm(true) : setValidForm(false);
    }

    useEffect(() => {
        validateForm();
    }, [password, verifyPassword, privacy]);

    return (
        <div style={{
            display: "block",
            margin: "auto"
        }}>
            <h2 style={{fontSize: "18px"}}>{t("auth:reset.title")}</h2>
            <p>{t("auth:reset.text")}</p>
            <PasswordInput
                label={t("welcome.password")}
                style={loginItemStyle}
                value={password.value}
                setValue={validatePassword}
                onKeyDown={handleEnter}
            />
            <PasswordInput
                label={t("welcome.verifyPassword")}
                style={loginItemStyle}
                value={verifyPassword.value}
                setValue={valueVerifyPassword}
                onKeyDown={handleEnter}
            />
            <div style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "15px"
            }}>
                <div style={{
                    display: "flex"
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        border: "1px solid black",
                        borderRadius: 25,
                        marginRight: 10
                    }}>
                        <Icon icon="high-priority" iconSize={12} style={{margin: "auto"}}/>
                    </div>
                    <span>{t("requirements.title")}</span>
                </div>
                <ul>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.characters")}
                            </div>
                            <div>
                                {validInputs.validLength && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.lower")}
                            </div>
                            <div>
                                {validInputs.validLower && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.upper")}
                            </div>
                            <div>
                                {validInputs.validUpper && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.number")}
                            </div>
                            <div>
                                {validInputs.validNumber && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.special")}
                            </div>
                            <div>
                                {validInputs.validSpecial && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                </ul>
                <div style={{display: "flex"}}>
                    <div style={{
                        width: "18px",
                        height: "18px",
                        overflow: "hidden",
                        marginRight: "15px"
                    }}>
                        <Checkbox
                            checked={privacy}
                            onChange={() => setPrivacy(privacy => !privacy)}
                        />
                    </div>
                    <div>
                        <p>{t("terms.text1")} <a style={termStyle} href={"#"}>{t("terms.cond")}</a> {t("terms.text2")} <a style={termStyle} href={"#"}>{t("terms.privacy")}</a></p>
                    </div>
                </div>
            </div>
            <div style={{
                display: "flex",
                marginTop: "15px"
            }}>
                <Button
                    intent="cancel"
                    text={t("action.cancel")}
                    action={() => !!to && history.push(to)}
                    style={{
                        marginRight: "15px",
                    }}
                />
                <Button
                    intent="primary"
                    text={t("action.signin")}
                    disabled={validForm}
                    action={() => {
                        auth.resetPassword(token, password.value, verifyPassword.value);
                    }}
                />
            </div>
            {!!auth && !!auth.loginError && (
                <div style={{
                    backgroundColor: "#ffdddd",
                    color: "#ff0000",
                    border: "1px solid #ff0000",
                    borderRadius: 3,
                    fontWeight: "bold",
                    marginTop: 15,
                    padding: 8
                }}>
                    {auth.loginError}
                </div>
            )}
        </div>
    );
};

export default ResetPasswordPage;

const loginItemStyle = {
    marginTop: 15,
    display: "flex",
    flexDirection: "column",
    width: "200px"
}

const termStyle = {
    color: "black",
    fontWeight: 600,
    textDecoration: "underline"
}

const liStyle = {
    marginTop: "5px",
    width: "200px"
}